import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import "../styles/cd.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Alert, Avatar, Button, Card, Input, Modal, QRCode, Space, Tabs, Tag, Typography } from "antd";
import { notify } from "../components/Customs/NotifyProvider";
import { ENDPOINT } from "../Services/ENDPOINT";
import { navigate } from "../components/Customs/navigation";
import CarCard from "../components/List/CarData";
import SignUpPage from "./SignUpPage";


const { Text } = Typography;

const ChekoutPage = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const [open, setOpen] = useState(false);
    const [utr, setUtr] = useState("");

    const [bookingData, setBookingData] = useState({});
    const [carData, setCarData] = useState(null);
    const [addonServices, setAddonServices] = useState([]);

    const [totalAddon, setTotalAddon] = useState(0);
    const [couponDiscount, setCouponDiscount] = useState(0);

    const [couponCode, setCouponCode] = useState("");
    const [couponApplied, setCouponApplied] = useState(false);
    const [couponData, setCouponData] = useState(null);
    const [paymentType, setPaymentType] = useState("full");
    const [payAmount, setPayAmount] = useState(0);
    const [userKey, setUserKey] = useState('');

    const [openCheckout, setOpenCheckout] = useState(false);
    const [droptype, setDroptype] = useState(null);

    const [form, setForm] = useState({
        fullName: "",
        mobile: "",
        email: "",
        pickup: "",
        company_name: "",
        gst: ""
    });

    /* ================= FETCH DATA ================= */
    useEffect(() => {
        const data = location.state?.data;

        if (!data) return;

        console.log("0000000", data.droptype);

        setDroptype(data.droptype);


        setBookingData(data);
        const userKey = localStorage.getItem('hc-user-key');

        console.log("userKey", userKey);

        setUserKey(userKey);
        console.log(userKey);
        if (userKey) {
            setForm(prev => ({
                ...prev,
                email: userKey
            }));
        }


        // console.log("XXXX",droptype,droptype === "premium" ? data.total_distance * 2 : data.total_distance);


        axios
            .post(`${ENDPOINT.base}${ENDPOINT.sub_url}${ENDPOINT.car_distance}${data.carId}`, {
                // total_distance: data.total_distance,
                total_distance: data.droptype === "premium" ? data.total_distance * 2 : data.total_distance,
                rental_hour: data?.rental_duration,
                // totalDay: data?.totalDay 
                totalDay:
                    data.droptype === "premium" || data.droptype === "regular"
                        ? 1
                        : data?.totalDay

                // droptype
            })
            .then(res => setCarData(res.data.data));

        axios
            .get(`${ENDPOINT.addon_services}`)
            .then(res =>
                setAddonServices(
                    (res.data.data || []).map(a => ({ ...a, selected: false }))
                )
            );
    }, [location.state]);



    /* ================= HELPERS ================= */
    const baseAmount = carData?.calculation?.discounted_price || 0;
    const originalPrice = carData?.calculation?.original_price || baseAmount;

    const getAddonPrice = (addon) =>
        addon.price_type === "per_km"
            ? addon.price * (bookingData.total_distance || 0)
            : addon.price;

    const formatPrice = (v) => Number(v || 0).toFixed(2);

    /* ================= COUPON RECALC ================= */
    const recalculateCoupon = (newSubtotal) => {
        if (!couponApplied || !couponData) return;

        const discountAmount = Math.round(
            (newSubtotal * couponData.percent) / 100
        );

        setCouponDiscount(discountAmount);
    };

    /* ================= ADDON TOGGLE ================= */
    const toggleAddon = (index) => {
        const updated = addonServices.map((a, i) =>
            i === index ? { ...a, selected: !a.selected } : a
        );

        const total = updated.reduce(
            (sum, a) => (a.selected ? sum + getAddonPrice(a) : sum),
            0
        );

        setAddonServices(updated);
        setTotalAddon(total);

        const newSubtotal = baseAmount + total;
        recalculateCoupon(newSubtotal);
    };

    /* ================= PRICE ================= */
    const subtotal = baseAmount + totalAddon;
    const finalTotal = Math.max(subtotal - couponDiscount, 0);
    const partPay = Math.round(finalTotal * 0.25);


    const payableLink = `upi://pay?pa=arokialawrance@okicici&pn=Arokia%20Lawrance&am=${payAmount}&cu=INR&aid=uGICAgID109LOGw`;

    const openUpiApp = () => {
        window.open(payableLink, "_blank");
    };

    const handleCloseLogin = () => {
        const userKey = localStorage.getItem("hc-user-key");

        if (userKey) {
            setForm(prev => ({
                ...prev,
                email: userKey
            }));
        }

        setOpenCheckout(false);
    };

    const handleConfirm = () => {

        const userKey = localStorage.getItem("hc-user-key");

        if (!form.fullName || !form.mobile) {
            alert("Fill all required fields");
            return;
        }
        if (!form.email && !userKey) {
            alert("Fill all required fields");
            return;
        }

        // If user is NOT logged in → redirect to signup
        if (!userKey) {
            // navigate("/signup", {
            //     state: {
            //         redirectTo: "/car-booking",
            //         data: { ...carData, bookingData } //carId
            //     }
            // });
            setOpenCheckout(true);
            return;
        }

        if (paymentType === "onsite") {
            submitOrder("ONSITE", "on-site"); // pass dummy UTR
            return;
        }


        setOpen(true);

        if (!utr) {
            console.warn("UTR not provided");
            return;
        }


        console.log("UTR ID:", utr);
        console.log("Payment Link:", payableLink);

    };

    const handleConfirPay = async () => {
        setOpen(false);
        if (utr?.trim()) {
            submitOrder(utr, payableLink);
        }
    }

    useEffect(() => {
        if (paymentType === "full") {
            setPayAmount(finalTotal);
        } else if (paymentType === "part") {
            setPayAmount(partPay);
        } else {
            setPayAmount(0);
        }
    }, [paymentType, finalTotal, partPay]);

    /* ================= APPLY COUPON ================= */
    const applyCoupon = async () => {
        if (!couponCode.trim()) {
            alert("Please enter a coupon code");
            return;
        }

        try {
            const res = await axios.get(
                `${ENDPOINT.apply_coupon}${couponCode}`
            );

            if (res.data?.status === true) {
                const coupon = res.data.data;
                const discountPercent = Number(coupon.dis_per || 0);
                const discountAmount = Math.round((subtotal * discountPercent) / 100);

                setCouponApplied(true);
                setCouponDiscount(discountAmount);
                setCouponData({
                    id: coupon.id,
                    code: coupon.c_code,
                    percent: discountPercent,
                    amount: discountAmount
                });

                alert(`Coupon Applied! You saved ₹${discountAmount}`);
            } else {
                alert(res.data?.message || "Invalid coupon");
            }
        } catch (error) {
            console.error("Coupon Error:", error);
            alert("Failed to apply coupon");
        }
    };

    /* ================= CLEAR COUPON ================= */
    const clearCoupon = () => {
        setCouponCode("");
        setCouponApplied(false);
        setCouponDiscount(0);
        setCouponData(null);
    };

    /* ================= SUBMIT ================= */
    // const submitOrder = async (utr, payLink) => {



    //     if (!form.fullName || !form.mobile || !form.email) {
    //         alert("Fill all required fields");
    //         return;
    //     }

    //     const selectedAddons = addonServices.filter(a => a.selected);

    //     const payload = {
    //         user: form,
    //         trip: bookingData,
    //         car: carData,
    //         addons: selectedAddons,
    //         pricing: {
    //             originalPrice,
    //             discountedPrice: baseAmount,
    //             totalAddons: totalAddon,
    //             finalPrice: finalTotal,
    //             couponDiscount
    //         },
    //         pay_type: {
    //             payment_type: paymentType,
    //             pay_amount: payAmount
    //         },
    //         status: "Order Confirmed",
    //         type: bookingData.type,
    //         userKey: userKey,
    //         utr_id: utr
    //     };
    //     console.log(payload);


    //     try {
    //         const res = await axios.post(
    //             `${ENDPOINT.orders}`,
    //             payload
    //         );
    //         alert(res.data.status ? "Order confirmed!" : "Booking failed");

    //         if (res.data.status) {
    //             notify.success("Order Confirmed!");
    //             setUtr('')
    //             window.location.reload();
    //         } else {
    //             notify.warning("Please try again");
    //             setUtr('')
    //         }
    //     } catch (err) {
    //         alert("Server error", err);
    //         setUtr('')
    //     }
    // };

    // const payableLink = () => {
    //     const payableLink = `upi://pay?pa=iamranjith9.15@oksbi&pn=Ranjith&am=${payAmount}.00&cu=INR&aid=uGICAgIDLq72gKw`
    //     console.log(payableLink, "payableLink");

    // }

    // Add these state variables near your other useState declarations
    const [resultModal, setResultModal] = useState({ open: false, success: false, message: "" });

    // Replace the submitOrder function's alert logic:
    const submitOrder = async (utr, payLink) => {
        if (!form.fullName || !form.mobile || !form.email) {
            alert("Fill all required fields");
            return;
        }

        const calculation = carData.calculation || null;

        const selectedAddons = addonServices.filter(a => a.selected);

        const userKey = localStorage.getItem("hc-user-key");


        const payload = {
            user: form,
            trip: bookingData,
            car: carData,
            addons: selectedAddons,
            pricing: {
                originalPrice,
                discountedPrice: baseAmount,
                totalAddons: totalAddon,
                finalPrice: finalTotal,
                couponDiscount
            },
            pay_type: {
                payment_type: paymentType,
                pay_amount: payAmount
            },

            summary: {
                car_name: carData?.car_name || "",
                rental_duration: bookingData?.rental_duration || "",
                total_rental_days: bookingData?.totalDay || "",
                pickup_date: bookingData?.pickup_date || "",
                pickup_time: bookingData?.pickup_time || "",
                total_travel_km: droptype === "premium"
                    ? (bookingData?.total_distance || 0) * 2
                    : bookingData?.total_distance || 0,
                included_km: calculation?.calculation_type === "day_wise"
                    ? Number(carData?.min_travel_range_km || 0) * Number(bookingData?.totalDay || 0)
                    : carData?.min_travel_range_km || 0,
                passenger_capacity: carData?.seater || "",
                additional_charge_per_km: carData?.additional_travel_amount
                    ? `₹${carData.additional_travel_amount} / km`
                    : "",
                additional_charge_per_hr: carData?.additional_travel_amount_per_hr
                    ? `₹${carData.additional_travel_amount_per_hr} / hr`
                    : "",
                base_price: calculation?.base_price || 0,
                extra_km: calculation?.extra_km || 0,
                extra_km_charge: calculation?.extra_km_charge || 0,
                per_km_price: calculation?.per_km_price || 0,
                rental_price: calculation?.rentalDayPrice || 0,
                per_day_rental_price: calculation?.perDayRentalPrice || 0,
                driver_bata_per_day: calculation?.driver_bata_per_day || 0,
                total_driver_bata: calculation?.total_driver_bata || 0,
                discount_percent: calculation?.discount_percent || 0,
                discount_amount: calculation?.discount_amount || 0,
                total_price: calculation?.discounted_price || 0,
                route: bookingData?.from && bookingData?.to
                    ? `${bookingData.from} → ${bookingData.to}`
                    : "",
            },

            status: "Order Confirmed",
            type: bookingData.type,
            userKey: userKey,
            utr_id: utr
        };

        try {
            console.log("payload", payload);

            const res = await axios.post(`${ENDPOINT.orders}`, payload);

            if (res.data.status) {
                setResultModal({ open: true, success: true, message: "Your booking is confirmed! We'll see you on your trip." });
                notify.success("Order Confirmed!");
                setUtr('');
            } else {
                setResultModal({ open: true, success: false, message: "Booking failed. Please try again." });
                notify.warning("Please try again");
                setUtr('');
            }
        } catch (err) {
            setResultModal({ open: true, success: false, message: "Server error. Please try again later." });
            setUtr('');
        }
    };

    const renderList = (text, dotClass = "") => {
        if (!text || typeof text !== "string") return null;

        return text.split("|").map((item, i) => (
            <li key={i} className="tab-list-item">
                <span className={`dot ${dotClass}`}></span>
                {item.trim()}
            </li>
        ));
    };


    /* ================= RENDER ================= */
    return (
        <div className="cd-container">
            <Modal
                open={openCheckout}
                footer={null}
                onCancel={() => setOpenCheckout(false)}
                width={900}
                destroyOnClose
            >
                <SignUpPage
                    handleCloseLogin={handleCloseLogin}
                />
            </Modal>


            <Modal
                title="Complete Your Payment"
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                centered
            >
                <Space direction="vertical" size="large" style={{ width: "100%", alignItems: "center" }}>

                    <div style={{ paddingTop: '6px', }}></div>
                    <Tag
                        style={{
                            borderRadius: 40,
                            padding: "6px 16px",
                            border: "1.5px solid #378ADD",
                            background: "#E6F1FB",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                        }}
                    >
                        <Avatar size={26} style={{ background: "#185FA5", fontSize: 11, marginLeft: -10 }}>AL</Avatar>
                        <Text strong style={{ fontSize: 15, color: "#185FA5", margin: 0 }}>
                            Arokia Lawrance
                        </Text>
                    </Tag>
                    {/* QR Code */}
                    <QRCode value={payableLink} size={220} />

                    <Text type="secondary">
                        Scan the QR using any UPI app or click below
                    </Text>

                    <Alert
                        message={
                            <Space direction="vertical" size={4} style={{ width: "100%" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Text style={{ fontSize: 13 }}>
                                        <Text type="secondary">UPI No: </Text>
                                        <Text strong>9740071360</Text>
                                    </Text>
                                    <Button
                                        size="small"
                                        icon={<i className="fas fa-copy" />}
                                        onClick={() => navigator.clipboard.writeText("9740071360").then(() => notify.success("Copied!"))}
                                    />
                                </div>

                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Text style={{ fontSize: 13 }}>
                                        <Text type="secondary">UPI ID: </Text>
                                        <Text strong>arokialawrance@okicici</Text>
                                    </Text>
                                    <Button
                                        size="small"
                                        icon={<i className="fas fa-copy" />}
                                        onClick={() => navigator.clipboard.writeText("arokialawrance@okicici").then(() => notify.success("Copied!"))}
                                    />
                                </div>
                            </Space>
                        }
                        type="info"
                        style={{ marginBottom: 16, width: "110%" }}
                    />
                    {/* Open UPI Link */}
                    <Button type="dashed" onClick={openUpiApp}>
                        Open UPI App
                    </Button>

                    {/* UTR Input */}
                    <Input
                        placeholder="Enter UTR / Transaction ID"
                        value={utr}
                        onChange={(e) => setUtr(e.target.value)}
                    />

                    {/* Confirm Button */}
                    <Button
                        type="primary"
                        block
                        disabled={!utr.trim()}
                        onClick={handleConfirPay}
                    >
                        Confirm Payment
                    </Button>
                </Space>
            </Modal>

            <div className="left-column">

                {carData && (
                    <div >
                        {/* <div className="route-info"> */}
                        {/* {bookingData?.from?.trim() && bookingData?.to?.trim() && (
                                <div className="route-title">
                                    {bookingData.from} → {bookingData.to}
                                </div>
                            )} */}

                        {/* <div className="route-details">
                                <div><strong>Car:</strong> {carData.car_name}</div>
                                {(bookingData.pickup_date || bookingData.pickup_time) && (
                                    <div>
                                        <strong>Pickup:</strong> {bookingData.pickup_date} {bookingData.pickup_time}
                                    </div>
                                )}

                                {bookingData.total_distance && (
                                    <div>
                                        <strong>KMs:</strong> {bookingData.total_distance}
                                    </div>
                                )}

                            </div> */}
                        {/* </div> */}
                    </div>
                )}

                {carData && (
                    <div className="row">
                        <CarCard
                            bookingData={bookingData}
                            car={carData}
                            droptype={droptype}
                        />
                    </div>
                )}



                {/* CONTACT */}
                <div className="card">
                    <div className="section-title">Contact Details</div>
                    <input placeholder="Full Name" onChange={e => setForm({ ...form, fullName: e.target.value })} />
                    <input placeholder="Mobile" onChange={e => setForm({ ...form, mobile: e.target.value })} />
                    <input placeholder="Email" value={userKey} onChange={e => setForm({ ...form, email: e.target.value })} />
                    <input placeholder="Pickup Location" onChange={e => setForm({ ...form, pickup: e.target.value })} />
                    <input placeholder="Company Name (Optional)" onChange={e => setForm({ ...form, company_name: e.target.value })} />
                    <input placeholder="GST (Optional)" onChange={e => setForm({ ...form, gst: e.target.value })} />
                </div>

                {/* ADDONS */}
                <div className="card">
                    <div className="personalize-title">Personalize Your Journey</div>

                    {addonServices
                        .filter(addon => getAddonPrice(addon) > 0)
                        .map((addon, index) => (
                            <div
                                key={index}
                                className={`addon-item ${addon.selected ? "active" : ""}`}
                                onClick={() => toggleAddon(index)}
                            >
                                <div className="addon-left">
                                    <input
                                        type="checkbox"
                                        checked={addon.selected}
                                        onChange={() => toggleAddon(index)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <div>
                                        <label>{addon.name}</label>
                                        <p>{addon.description}</p>
                                    </div>
                                </div>

                                <div className="addon-price">
                                    ₹{formatPrice(getAddonPrice(addon))}
                                </div>
                            </div>
                        ))}

                </div>

                {carData && (
                    <Card className="card">
                        <Tabs
                            centered
                            items={[
                                { key: "1", label: "Inclusion", children: <>{renderList(carData.inclusion, "dot-green")}</> },
                                { key: "2", label: "Exclusion", children: <>{renderList(carData.exclusion, "dot-red")}</> },
                                { key: "3", label: "Terms", children: <>{renderList(carData.description)}</> }
                            ]}
                        />
                    </Card>
                )}
            </div>

            {/* RIGHT SIDE */}
            <div
                style={{
                    position: "sticky",
                    top: "20px",
                    alignSelf: "flex-start",
                    height: "fit-content",
                    display: window.innerWidth >= 992 ? "block" : "static"
                }}
            >
                <div className="card">
                    {/* <div className="section-title">Payment</div>

                    <div className="payment-option">
                        <div>Full Pay</div>
                        <div>₹{formatPrice(finalTotal)}</div>
                    </div>

                    <div className="payment-option">
                        <div>Part Pay</div>
                        <div>₹{formatPrice(partPay)}</div>
                    </div>

                    <div className="payment-option">
                        <div>Onsite Pay</div>
                        <div>₹{formatPrice(0)}</div>
                    </div> */}

                    {/* <div className="card"> */}
                    <div>
                        <div className="section-title">Payment</div>

                        <div
                            className={`payment-option ${paymentType === "full" ? "active" : ""}`}
                            onClick={() => setPaymentType("full")}
                            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}
                        >
                            <input
                                type="radio"
                                checked={paymentType === "full"}
                                readOnly
                                className="hidden-radio"
                            />
                            <div style={{ flex: 1, display: "flex", justifyContent: "space-between" }}>
                                <div>Full Pay</div>
                                <div>₹{formatPrice(finalTotal)}</div>
                            </div>
                        </div>

                        <div
                            className={`payment-option ${paymentType === "part" ? "active" : ""}`}
                            onClick={() => setPaymentType("part")}
                            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}
                        >
                            <input
                                type="radio"
                                checked={paymentType === "part"}
                                readOnly
                                className="hidden-radio"
                            />
                            <div style={{ flex: 1, display: "flex", justifyContent: "space-between" }}>
                                <div>Part Pay</div>
                                <div>₹{formatPrice(partPay)}</div>
                            </div>
                        </div>

                        <div
                            className={`payment-option ${paymentType === "onsite" ? "active" : ""}`}
                            onClick={() => setPaymentType("onsite")}
                            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}
                        >
                            <input
                                type="radio"
                                checked={paymentType === "onsite"}
                                readOnly
                                className="hidden-radio"
                            />
                            <div style={{ flex: 1, display: "flex", justifyContent: "space-between" }}>
                                <div>Onsite Pay</div>
                                <div>₹0</div>
                            </div>
                        </div>

                    </div>


                    {/* COUPON */}
                    <div className="coupon-section">
                        {!couponApplied ? (
                            <>
                                <input
                                    placeholder="ENTER COUPON"
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value)}
                                />
                                <button onClick={applyCoupon}>Apply</button>
                            </>
                        ) : (
                            <button
                                onClick={clearCoupon}
                                style={{ background: "#ff4d4f", color: "#fff" }}
                            >
                                Remove
                            </button>
                        )}

                        {couponApplied && (
                            <div style={{ marginTop: 8, color: "green" }}>
                                Coupon <b>{couponData?.code}</b> applied —
                                You saved ₹{couponDiscount}
                            </div>
                        )}
                    </div>

                    <button className="proceed-btn" onClick={handleConfirm}>
                        PROCEED
                    </button>
                </div>
            </div>

            <Modal
                open={resultModal.open}
                footer={null}
                onCancel={() => {
                    setResultModal({ open: false, success: false, message: "" });
                    if (resultModal.success) window.location.reload();
                }}
                centered
                width={400}
            >
                <div style={{ textAlign: "center", padding: "24px 16px" }}>
                    <div style={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        background: resultModal.success ? "#f6ffed" : "#fff2f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 16px",
                        fontSize: 28
                    }}>
                        {resultModal.success ? "✅" : "❌"}
                    </div>

                    <div style={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: resultModal.success ? "#52c41a" : "#ff4d4f",
                        marginBottom: 8
                    }}>
                        {resultModal.success ? "Order Confirmed!" : "Booking Failed"}
                    </div>

                    <div style={{ color: "#666", marginBottom: 24, fontSize: 14 }}>
                        {resultModal.message}
                    </div>

                    <Button
                        type="primary"
                        block
                        onClick={() => {
                            setResultModal({ open: false, success: false, message: "" });
                            if (resultModal.success) window.location.reload();
                        }}
                        style={{
                            background: resultModal.success ? "#52c41a" : "#ff4d4f",
                            borderColor: resultModal.success ? "#52c41a" : "#ff4d4f"
                        }}
                    >
                        {resultModal.success ? "Great, thanks!" : "Try Again"}
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default ChekoutPage;
